// Gentle "What you've protected" moment categories.

export const MOMENT_TYPES = {
  reached: {
    id: "reached",
    label: "Reached before the spiral",
    short: "Reached out",
    accent: "#5B3954",
  },
  safer: {
    id: "safer",
    label: "Made a safer choice",
    short: "Safer choice",
    accent: "#7A5C63",
  },
  interrupted: {
    id: "interrupted",
    label: "Interrupted a spiral",
    short: "Spiral interrupted",
    accent: "#8E6C88",
  },
  repair: {
    id: "repair",
    label: "Attempted repair",
    short: "Repair attempt",
    accent: "#5C4A57",
  },
  protected: {
    id: "protected",
    label: "Protected someone or something I love",
    short: "Protected what matters",
    accent: "#4A6B5D",
  },
};

export const MOMENT_ORDER = [
  "reached",
  "safer",
  "interrupted",
  "repair",
  "protected",
];
